import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { OldMangoButton } from '~/components/core/OldMangoButton'

import iconNoSearchXDark700 from '../assets/icons-light-theme/icon-noSearchX-dark700.svg'
import { light, spacing } from '../constants/theme'
import { Text } from './core'
import { ImageIcon } from './ImageIcon'

const EmptyStateWrapper = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${light.gray200};
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

const TitleWrapper = styled.div`
  margin-top: ${spacing.spacingXXXL};
  text-align: center;
  font-weight: bold;
`

const SubtitleWrapper = styled.div`
  margin-bottom: 48px;
  margin-top: ${spacing.spacingSM};
`

const EmptyState = (
  { title, subtitle, subtitle2, buttonText, onClick, icon } = {
    title: '',
    subtitle: '',
    subtitle2: '',
    buttonText: '',
    onClick: '',
    icon: true,
  },
) => (
  <EmptyStateWrapper>
    {icon && <ImageIcon width="48" height="48" icon={iconNoSearchXDark700} />}
    <TitleWrapper>
      {title && (
        <Text
          size="medium"
          align="center"
          weight="bold"
          color={light.dark700}
          text={title}
        />
      )}
    </TitleWrapper>
    <SubtitleWrapper>
      <Text
        text={subtitle}
        size="normal"
        align="center"
        weight="normal"
        color={light.dark700}
      />
    </SubtitleWrapper>
    {subtitle2 && (
      <SubtitleWrapper>
        <Text
          text={subtitle2}
          size="normal"
          align="center"
          weight="normal"
          color={light.dark700}
        />
      </SubtitleWrapper>
    )}

    {onClick && <OldMangoButton onClick={onClick}>{buttonText}</OldMangoButton>}
  </EmptyStateWrapper>
)

EmptyState.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subtitle2: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.bool,
}

export { EmptyState }
